/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Location_PlaceholderInputs */

const en_job_form_location_placeholder = /** @type {(inputs: Job_Form_Location_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Frankfurt`)
};

const de_job_form_location_placeholder = /** @type {(inputs: Job_Form_Location_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Frankfurt`)
};

/**
* | output |
* | --- |
* | "e.g. Frankfurt" |
*
* @param {Job_Form_Location_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_location_placeholder = /** @type {((inputs?: Job_Form_Location_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Location_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_location_placeholder(inputs)
	return en_job_form_location_placeholder(inputs)
});